import { Component } from '@angular/core';
import { ConfigurationsBlockComponent } from '../configurations-block/configurations-block.component';

@Component({
  templateUrl: 'game-client-configurations.component.html',
  standalone: true,
  imports: [ConfigurationsBlockComponent]
})
export class GameClientConfigurationsComponent {}
